<template>
  <div id="app">
    <header>
      <nav class="navbar">
        <div class="brand-logo menu">
          <router-link to="/">
            <img src="./assets/catena-logo.svg" alt="Catena Logo" />
          </router-link>
        </div>
        <div class="menu">
          <router-link to="/">Home</router-link>
          <router-link to="/sobre">Sobre nós</router-link>
          <router-link to="/contato">Contato</router-link>
        </div>
      </nav>
    </header>

    <router-view />

    <footer>
      <p>CATENA SYSTEM | 48.126.659/0001-15 | Todos os direitos reservados | <router-link to="/politica-de-privacidade">Política de Privacidade</router-link></p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Montserrat", sans-serif;
  text-align: center;
  color: #fff;
}

.navbar .brand-logo,
.navbar .menu a,
.banner-content h1,
.banner-content h2,
.banner-content p,
footer p {
  font-family: "Montserrat", sans-serif;
}

.home-header {
  position: relative;
  background: url("./assets/banner-home.jpg") no-repeat center center/cover;
  height: 100vh;
  color: white;
}
.navbar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  background-color: #274862;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
}

.navbar .brand-logo {
  font-size: 1.5em;
  font-weight: bold;
  align-items: center;
}

.navbar .brand-logo img {
  width: 100px;
  height: auto;
  margin-right: 10px;
}

.navbar .menu a {
  margin: 0 20px;
  color: white;
  text-decoration: none;
  font-size: 1em;
}
.navbar .menu a:hover {
  color: #9dee9c;
}

header {
  color: white;
}
html,
body {
  font-family: "Montserrat", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow-x: hidden;
}

footer {
  background-color: #274862;
  color: white;
  padding: 10px;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 0.7em;
}
footer a {
  color: white;
  text-decoration: none;
}

footer a:hover {
  color: #9dee9c;
}

.navbar .menu a:hover {
  color: #9dee9c;
}

.banner {
  background: no-repeat center center/cover;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 50px;
}

.banner-content {
  background-color: #274862;
  color: white;
  padding: 50px;
  text-align: left;
  max-width: 700px;
  border-radius: 0px 16px 16px 0px;
  opacity: 0.85;
}

.banner-content h1 {
  font-size: 2em;
  margin: 0;
}

.banner-content h2 {
  font-size: 1.8em;
  margin-top: 10px;
}

.banner-content p {
  font-size: 1.2em;
  margin-top: 20px;
}

.cta-button {
  padding: 15px 30px;
  background-color: #9dee9c;
  border: none;
  color: #274862;
  font-size: 1em;
  cursor: pointer;
  border-radius: 5px;
  font-weight: 600;
}

.cta-button:hover {
  background-color: #82c582;
}

.section-itens {
  background-color: #274862;
  color: white;
  padding: 50px 100px;
  text-align: center;
}

.section-itens h2 {
  font-size: 1.6em;
  margin-bottom: 50px;
}

.section-grid {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .banner-content {
    max-width: 90%;
    padding: 20px;
  }

  .navbar {
    flex-direction: column;
  }

  .navbar .menu {
    margin-top: 10px;
  }
}
</style>
